/** 
 * Manages z-index for draggable elements (thumbnails) to ensure correct stacking order
 * Use this object for every thumbnail
 */

class ZIndexManager {
  private thumbnails: Map<string, { el: HTMLElement; z: number }> = new Map();
  private baseZ = 100; // starting z-index
  private nextZ = this.baseZ;

  register(id: string, el: HTMLElement) {
    const current = this.thumbnails.get(id);
    if (current) {
      // already registered → just update element
      current.el = el;
    } else {
      this.thumbnails.set(id, { el, z: this.nextZ++ });
    }
    this.applyZIndices();
  }

  bringToFront(id: string) {
    const item = this.thumbnails.get(id);
    if (!item) return;

    // Remove from current position
    this.thumbnails.delete(id);

    // Put at the end (highest z)
    this.thumbnails.set(id, { ...item, z: this.nextZ++ });

    this.applyZIndices();

    // console.debug("thumbnail '" + item.title + "' sent to front")
  }

  private applyZIndices() {
    let z = this.baseZ;
    for (const [_id, { el }] of this.thumbnails) {
      el.style.zIndex = String(z++);
    }
  }

  getCurrentZ(id: string): number | undefined {
    return this.thumbnails.get(id)?.z;
  }
}

/* __________________________________________________________________________
|                                E X P O R T                                |
|___________________________________________________________________________*/


// Singleton instance (or inject via constructor if preferred)
export const zIndexManager = new ZIndexManager();